import { atomFamily } from "recoil";

export const editAddressState = atomFamily({
  key: "editAddress",
  default: {},
});
